export default {
  DIALOGS_TOP_INDENT: 25,
  DESKTOP_BREAKPOINT: '1024px',
};
